module.exports = __webpack_public_path__ + "img/easter.6c174347.gif";